export const splitWeightInPoundsAndOunces = (weight) => {
  const defaultWeight = {
    pounds: 0,
    ounces: 0
  }

  if (!weight || isNaN(weight)) {
    return defaultWeight
  }

  return {
    pounds: Math.floor(weight / 16),
    ounces: weight % 16
  }
}

export const mergePoundsAndOuncesIntoWeight = (weight) => {
  const defaultWeight = 0
  var poundsInOunces = 0
  var ounces = 0

  if (!weight) {
    return defaultWeight
  }

  if (weight.pounds) {
    const parsedPounds = isNaN(parseFloat(weight.pounds)) ? 0 : parseFloat(weight.pounds)
    poundsInOunces = parsedPounds * 16
  }

  if (weight.ounces) {
    ounces = isNaN(parseFloat(weight.ounces)) ? 0 : parseFloat(weight.ounces)
  }

  return poundsInOunces + ounces
}
